import { createFileRoute } from "@tanstack/react-router"
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { NoteFormPage } from "~/pages/NoteFormPage"

export const Route = createFileRoute("/_dashboard/$datasetSlug/notes/$id/edit")(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  const { id, datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Notes", link: `/${datasetSlug}/notes` },{ title: "Edit", link: `/${datasetSlug}/notes/${id}/edit` }]);
  return <NoteFormPage noteId={id}/>
}
